import { render } from "./Instructions.vue?vue&type=template&id=74e7f39a&scoped=true"
const script = {}

import "./Instructions.vue?vue&type=style&index=0&id=74e7f39a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-74e7f39a"

export default script